import { Controller } from "@hotwired/stimulus"

// Drives the GotPOS-themed app shell's sidebar: on desktop, the toggle
// collapses the sidebar to an icon-only rail via the `data-sidebar`
// attribute (persisted in localStorage); on mobile/tablet, the sidebar is
// permanently off-canvas (`body.sidebar-hidden`) and the toggle slides it
// in/out with a dismissible backdrop.
const MOBILE_BREAKPOINT = 991.98

export default class extends Controller {
  static targets = ["sidebar", "backdrop"]

  connect() {
    if (localStorage.getItem("sidebarSize") === "small") {
      document.documentElement.setAttribute("data-sidebar", "small")
    }

    this.applyResponsiveState()
    this.resizeHandler = () => this.applyResponsiveState()
    window.addEventListener("resize", this.resizeHandler)
  }

  disconnect() {
    window.removeEventListener("resize", this.resizeHandler)
  }

  applyResponsiveState() {
    document.body.classList.toggle("sidebar-hidden", window.innerWidth <= MOBILE_BREAKPOINT)
  }

  toggle() {
    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      this.sidebarTarget.classList.toggle("show")
      this.backdropTarget.classList.toggle("d-block")
    } else {
      const collapsed = document.documentElement.getAttribute("data-sidebar") === "small"
      document.documentElement.setAttribute("data-sidebar", collapsed ? "large" : "small")
      localStorage.setItem("sidebarSize", collapsed ? "large" : "small")
    }
  }

  closeMobile() {
    this.sidebarTarget.classList.remove("show")
    this.backdropTarget.classList.remove("d-block")
  }
}
